(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_city_smartb_f2_f2_dsl_cqrs.js', './kotlin_city_smartb_i2_commons_domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_city_smartb_f2_f2_dsl_cqrs.js'), require('./kotlin_city_smartb_i2_commons_domain.js'));
  else {
    if (typeof kotlin_city_smartb_f2_f2_dsl_cqrs === 'undefined') {
      throw new Error("Error loading module 'kotlin_city_smartb_i2_user_domain'. Its dependency 'kotlin_city_smartb_f2_f2_dsl_cqrs' was not found. Please, check whether 'kotlin_city_smartb_f2_f2_dsl_cqrs' is loaded prior to 'kotlin_city_smartb_i2_user_domain'.");
    }
    if (typeof kotlin_city_smartb_i2_commons_domain === 'undefined') {
      throw new Error("Error loading module 'kotlin_city_smartb_i2_user_domain'. Its dependency 'kotlin_city_smartb_i2_commons_domain' was not found. Please, check whether 'kotlin_city_smartb_i2_commons_domain' is loaded prior to 'kotlin_city_smartb_i2_user_domain'.");
    }
    root.kotlin_city_smartb_i2_user_domain = factory(typeof kotlin_city_smartb_i2_user_domain === 'undefined' ? {} : kotlin_city_smartb_i2_user_domain, kotlin_city_smartb_f2_f2_dsl_cqrs, kotlin_city_smartb_i2_commons_domain);
  }
}(this, function (_, kotlin_city_smartb_f2_f2_dsl_cqrs, kotlin_city_smartb_i2_commons_domain) {
  //region block: imports
  var Command = kotlin_city_smartb_f2_f2_dsl_cqrs.$crossModule$.Command;
  var Event = kotlin_city_smartb_f2_f2_dsl_cqrs.$crossModule$.Event;
  var KeycloakF2Command = kotlin_city_smartb_i2_commons_domain.$crossModule$.KeycloakF2Command;
  var KeycloakF2Result = kotlin_city_smartb_i2_commons_domain.$crossModule$.KeycloakF2Result;
  //endregion
  'use strict';
  //region block: pre-declaration
  //endregion
  function UserCreateCommand_init_$Init$(realmId, username, firstname, lastname, email, isEnable, metadata, auth, password, $mask0, $marker, $this) {
    if (!(($mask0 & 256) === 0))
      password = null;
    UserCreateCommand.call($this, realmId, username, firstname, lastname, email, isEnable, metadata, auth, password);
    return $this;
  }
  function UserCreateCommand_init_$Create$(realmId, username, firstname, lastname, email, isEnable, metadata, auth, password, $mask0, $marker) {
    return UserCreateCommand_init_$Init$(realmId, username, firstname, lastname, email, isEnable, metadata, auth, password, $mask0, $marker, Object.create(UserCreateCommand.prototype));
  }
  function UserCreateCommand(realmId, username, firstname, lastname, email, isEnable, metadata, auth, password) {
    var password_0 = password === void 1 ? null : password;
    this.realmId_1 = realmId;
    this.username_1 = username;
    this.firstname_1 = firstname;
    this.lastname_1 = lastname;
    this.email_1 = email;
    this.isEnable_1 = isEnable;
    this.metadata_1 = metadata;
    this.auth_1 = auth;
    this.password_1 = password_0;
  }
  UserCreateCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserCreateCommand.prototype._get_username__1834652085_ucaylx_k$ = function () {
    return this.username_1;
  };
  UserCreateCommand.prototype._get_firstname__2839684214_o2frm2_k$ = function () {
    return this.firstname_1;
  };
  UserCreateCommand.prototype._get_lastname__3508433354_d0a5h2_k$ = function () {
    return this.lastname_1;
  };
  UserCreateCommand.prototype._get_email__3207470005_hzgua3_k$ = function () {
    return this.email_1;
  };
  UserCreateCommand.prototype._get_isEnable__3587428894_bp904i_k$ = function () {
    return this.isEnable_1;
  };
  UserCreateCommand.prototype._get_metadata__416606844_6w1bwc_k$ = function () {
    return this.metadata_1;
  };
  UserCreateCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserCreateCommand.prototype._get_password__553687184_95nfrk_k$ = function () {
    return this.password_1;
  };
  UserCreateCommand.$metadata$ = {
    simpleName: 'UserCreateCommand',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserCreateCommand.prototype, 'realmId', {
    configurable: true,
    get: UserCreateCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'username', {
    configurable: true,
    get: UserCreateCommand.prototype._get_username__1834652085_ucaylx_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'firstname', {
    configurable: true,
    get: UserCreateCommand.prototype._get_firstname__2839684214_o2frm2_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'lastname', {
    configurable: true,
    get: UserCreateCommand.prototype._get_lastname__3508433354_d0a5h2_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'email', {
    configurable: true,
    get: UserCreateCommand.prototype._get_email__3207470005_hzgua3_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'isEnable', {
    configurable: true,
    get: UserCreateCommand.prototype._get_isEnable__3587428894_bp904i_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'metadata', {
    configurable: true,
    get: UserCreateCommand.prototype._get_metadata__416606844_6w1bwc_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'auth', {
    configurable: true,
    get: UserCreateCommand.prototype._get_auth__792765859_d3zq1v_k$
  });
  Object.defineProperty(UserCreateCommand.prototype, 'password', {
    configurable: true,
    get: UserCreateCommand.prototype._get_password__553687184_95nfrk_k$
  });
  function UserCreatedResult(id) {
    this.id_1 = id;
  }
  UserCreatedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserCreatedResult.$metadata$ = {
    simpleName: 'UserCreatedResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserCreatedResult.prototype, 'id', {
    configurable: true,
    get: UserCreatedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function UserDeleteCommand(id, realmId, auth) {
    this.id_1 = id;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserDeleteCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserDeleteCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserDeleteCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserDeleteCommand.$metadata$ = {
    simpleName: 'UserDeleteCommand',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserDeleteCommand.prototype, 'id', {
    configurable: true,
    get: UserDeleteCommand.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserDeleteCommand.prototype, 'realmId', {
    configurable: true,
    get: UserDeleteCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  Object.defineProperty(UserDeleteCommand.prototype, 'auth', {
    configurable: true,
    get: UserDeleteCommand.prototype._get_auth__792765859_d3zq1v_k$
  });
  function UserDeletedResult(id) {
    this.id_1 = id;
  }
  UserDeletedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserDeletedResult.$metadata$ = {
    simpleName: 'UserDeletedResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserDeletedResult.prototype, 'id', {
    configurable: true,
    get: UserDeletedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function UserDisableCommand(id, realmId, auth) {
    this.id_1 = id;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserDisableCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserDisableCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserDisableCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserDisableCommand.$metadata$ = {
    simpleName: 'UserDisableCommand',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserDisableCommand.prototype, 'id', {
    configurable: true,
    get: UserDisableCommand.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserDisableCommand.prototype, 'realmId', {
    configurable: true,
    get: UserDisableCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  Object.defineProperty(UserDisableCommand.prototype, 'auth', {
    configurable: true,
    get: UserDisableCommand.prototype._get_auth__792765859_d3zq1v_k$
  });
  function UserDisabledResult(id) {
    this.id_1 = id;
  }
  UserDisabledResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserDisabledResult.$metadata$ = {
    simpleName: 'UserDisabledResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserDisabledResult.prototype, 'id', {
    configurable: true,
    get: UserDisabledResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function UserEmailSendActionsCommand(userId, clientId, redirectUri, actions, realmId, auth) {
    this.userId_1 = userId;
    this.clientId_1 = clientId;
    this.redirectUri_1 = redirectUri;
    this.actions_1 = actions;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserEmailSendActionsCommand.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  UserEmailSendActionsCommand.prototype._get_clientId__3872690757_6zeunv_k$ = function () {
    return this.clientId_1;
  };
  UserEmailSendActionsCommand.prototype._get_redirectUri__2605105057_ry3m1r_k$ = function () {
    return this.redirectUri_1;
  };
  UserEmailSendActionsCommand.prototype._get_actions__469840308_7rqb3o_k$ = function () {
    return this.actions_1;
  };
  UserEmailSendActionsCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserEmailSendActionsCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserEmailSendActionsCommand.$metadata$ = {
    simpleName: 'UserEmailSendActionsCommand',
    kind: 'class',
    interfaces: [KeycloakF2Command]
  };
  Object.defineProperty(UserEmailSendActionsCommand.prototype, 'userId', {
    configurable: true,
    get: UserEmailSendActionsCommand.prototype._get_userId__2138184069_zd0pdx_k$
  });
  Object.defineProperty(UserEmailSendActionsCommand.prototype, 'clientId', {
    configurable: true,
    get: UserEmailSendActionsCommand.prototype._get_clientId__3872690757_6zeunv_k$
  });
  Object.defineProperty(UserEmailSendActionsCommand.prototype, 'redirectUri', {
    configurable: true,
    get: UserEmailSendActionsCommand.prototype._get_redirectUri__2605105057_ry3m1r_k$
  });
  Object.defineProperty(UserEmailSendActionsCommand.prototype, 'actions', {
    configurable: true,
    get: UserEmailSendActionsCommand.prototype._get_actions__469840308_7rqb3o_k$
  });
  Object.defineProperty(UserEmailSendActionsCommand.prototype, 'realmId', {
    configurable: true,
    get: UserEmailSendActionsCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  function UserEmailSentActionsResult(id) {
    this.id_1 = id;
  }
  UserEmailSentActionsResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserEmailSentActionsResult.$metadata$ = {
    simpleName: 'UserEmailSentActionsResult',
    kind: 'class',
    interfaces: [KeycloakF2Result]
  };
  Object.defineProperty(UserEmailSentActionsResult.prototype, 'id', {
    configurable: true,
    get: UserEmailSentActionsResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function UserJoinGroupCommand(id, groupId, realmId, auth) {
    this.id_1 = id;
    this.groupId_1 = groupId;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserJoinGroupCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserJoinGroupCommand.prototype._get_groupId__2632351319_rhvmp5_k$ = function () {
    return this.groupId_1;
  };
  UserJoinGroupCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserJoinGroupCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserJoinGroupCommand.$metadata$ = {
    simpleName: 'UserJoinGroupCommand',
    kind: 'class',
    interfaces: [KeycloakF2Command]
  };
  Object.defineProperty(UserJoinGroupCommand.prototype, 'id', {
    configurable: true,
    get: UserJoinGroupCommand.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserJoinGroupCommand.prototype, 'groupId', {
    configurable: true,
    get: UserJoinGroupCommand.prototype._get_groupId__2632351319_rhvmp5_k$
  });
  Object.defineProperty(UserJoinGroupCommand.prototype, 'realmId', {
    configurable: true,
    get: UserJoinGroupCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  function UserGroupJoinedResult(id, groupId) {
    this.id_1 = id;
    this.groupId_1 = groupId;
  }
  UserGroupJoinedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserGroupJoinedResult.prototype._get_groupId__2632351319_rhvmp5_k$ = function () {
    return this.groupId_1;
  };
  UserGroupJoinedResult.$metadata$ = {
    simpleName: 'UserGroupJoinedResult',
    kind: 'class',
    interfaces: [KeycloakF2Result]
  };
  Object.defineProperty(UserGroupJoinedResult.prototype, 'id', {
    configurable: true,
    get: UserGroupJoinedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserGroupJoinedResult.prototype, 'groupId', {
    configurable: true,
    get: UserGroupJoinedResult.prototype._get_groupId__2632351319_rhvmp5_k$
  });
  function UserRolesGrantCommand_init_$Init$(id, roles, auth, realmId, clientId, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      realmId = auth._get_realmId__1266573383_ky329z_k$();
    if (!(($mask0 & 16) === 0))
      clientId = null;
    UserRolesGrantCommand.call($this, id, roles, auth, realmId, clientId);
    return $this;
  }
  function UserRolesGrantCommand_init_$Create$(id, roles, auth, realmId, clientId, $mask0, $marker) {
    return UserRolesGrantCommand_init_$Init$(id, roles, auth, realmId, clientId, $mask0, $marker, Object.create(UserRolesGrantCommand.prototype));
  }
  function UserRolesGrantCommand(id, roles, auth, realmId, clientId) {
    var realmId_0 = realmId === void 1 ? auth._get_realmId__1266573383_ky329z_k$() : realmId;
    var clientId_0 = clientId === void 1 ? null : clientId;
    this.id_1 = id;
    this.roles_1 = roles;
    this.auth_1 = auth;
    this.realmId_1 = realmId_0;
    this.clientId_1 = clientId_0;
  }
  UserRolesGrantCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserRolesGrantCommand.prototype._get_roles__3581820084_bsl7ws_k$ = function () {
    return this.roles_1;
  };
  UserRolesGrantCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserRolesGrantCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserRolesGrantCommand.prototype._get_clientId__3872690757_6zeunv_k$ = function () {
    return this.clientId_1;
  };
  UserRolesGrantCommand.$metadata$ = {
    simpleName: 'UserRolesGrantCommand',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserRolesGrantCommand.prototype, 'id', {
    configurable: true,
    get: UserRolesGrantCommand.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserRolesGrantCommand.prototype, 'roles', {
    configurable: true,
    get: UserRolesGrantCommand.prototype._get_roles__3581820084_bsl7ws_k$
  });
  Object.defineProperty(UserRolesGrantCommand.prototype, 'auth', {
    configurable: true,
    get: UserRolesGrantCommand.prototype._get_auth__792765859_d3zq1v_k$
  });
  Object.defineProperty(UserRolesGrantCommand.prototype, 'realmId', {
    configurable: true,
    get: UserRolesGrantCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  Object.defineProperty(UserRolesGrantCommand.prototype, 'clientId', {
    configurable: true,
    get: UserRolesGrantCommand.prototype._get_clientId__3872690757_6zeunv_k$
  });
  function UserRolesGrantedResult(id) {
    this.id_1 = id;
  }
  UserRolesGrantedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserRolesGrantedResult.$metadata$ = {
    simpleName: 'UserRolesGrantedResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserRolesGrantedResult.prototype, 'id', {
    configurable: true,
    get: UserRolesGrantedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function UserRolesRevokeCommand(id, roles, auth) {
    this.id_1 = id;
    this.roles_1 = roles;
    this.auth_1 = auth;
  }
  UserRolesRevokeCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserRolesRevokeCommand.prototype._get_roles__3581820084_bsl7ws_k$ = function () {
    return this.roles_1;
  };
  UserRolesRevokeCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserRolesRevokeCommand.$metadata$ = {
    simpleName: 'UserRolesRevokeCommand',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserRolesRevokeCommand.prototype, 'id', {
    configurable: true,
    get: UserRolesRevokeCommand.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserRolesRevokeCommand.prototype, 'roles', {
    configurable: true,
    get: UserRolesRevokeCommand.prototype._get_roles__3581820084_bsl7ws_k$
  });
  Object.defineProperty(UserRolesRevokeCommand.prototype, 'auth', {
    configurable: true,
    get: UserRolesRevokeCommand.prototype._get_auth__792765859_d3zq1v_k$
  });
  function UserRolesRevokedResult(id) {
    this.id_1 = id;
  }
  UserRolesRevokedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserRolesRevokedResult.$metadata$ = {
    simpleName: 'UserRolesRevokedResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserRolesRevokedResult.prototype, 'id', {
    configurable: true,
    get: UserRolesRevokedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function UserUpdateCommand(userId, realmId, auth, firstname, lastname, email, metadata) {
    this.userId_1 = userId;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
    this.firstname_1 = firstname;
    this.lastname_1 = lastname;
    this.email_1 = email;
    this.metadata_1 = metadata;
  }
  UserUpdateCommand.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  UserUpdateCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserUpdateCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserUpdateCommand.prototype._get_firstname__2839684214_o2frm2_k$ = function () {
    return this.firstname_1;
  };
  UserUpdateCommand.prototype._get_lastname__3508433354_d0a5h2_k$ = function () {
    return this.lastname_1;
  };
  UserUpdateCommand.prototype._get_email__3207470005_hzgua3_k$ = function () {
    return this.email_1;
  };
  UserUpdateCommand.prototype._get_metadata__416606844_6w1bwc_k$ = function () {
    return this.metadata_1;
  };
  UserUpdateCommand.$metadata$ = {
    simpleName: 'UserUpdateCommand',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserUpdateCommand.prototype, 'userId', {
    configurable: true,
    get: UserUpdateCommand.prototype._get_userId__2138184069_zd0pdx_k$
  });
  Object.defineProperty(UserUpdateCommand.prototype, 'realmId', {
    configurable: true,
    get: UserUpdateCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  Object.defineProperty(UserUpdateCommand.prototype, 'auth', {
    configurable: true,
    get: UserUpdateCommand.prototype._get_auth__792765859_d3zq1v_k$
  });
  Object.defineProperty(UserUpdateCommand.prototype, 'firstname', {
    configurable: true,
    get: UserUpdateCommand.prototype._get_firstname__2839684214_o2frm2_k$
  });
  Object.defineProperty(UserUpdateCommand.prototype, 'lastname', {
    configurable: true,
    get: UserUpdateCommand.prototype._get_lastname__3508433354_d0a5h2_k$
  });
  Object.defineProperty(UserUpdateCommand.prototype, 'email', {
    configurable: true,
    get: UserUpdateCommand.prototype._get_email__3207470005_hzgua3_k$
  });
  Object.defineProperty(UserUpdateCommand.prototype, 'metadata', {
    configurable: true,
    get: UserUpdateCommand.prototype._get_metadata__416606844_6w1bwc_k$
  });
  function UserUpdatedResult(id) {
    this.id_1 = id;
  }
  UserUpdatedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserUpdatedResult.$metadata$ = {
    simpleName: 'UserUpdatedResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserUpdatedResult.prototype, 'id', {
    configurable: true,
    get: UserUpdatedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function UserGetAllQuery_init_$Init$(groupId, email, role, page, realmId, auth, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      groupId = null;
    if (!(($mask0 & 2) === 0))
      email = null;
    if (!(($mask0 & 4) === 0))
      role = null;
    UserGetAllQuery.call($this, groupId, email, role, page, realmId, auth);
    return $this;
  }
  function UserGetAllQuery_init_$Create$(groupId, email, role, page, realmId, auth, $mask0, $marker) {
    return UserGetAllQuery_init_$Init$(groupId, email, role, page, realmId, auth, $mask0, $marker, Object.create(UserGetAllQuery.prototype));
  }
  function UserGetAllQuery(groupId, email, role, page, realmId, auth) {
    var groupId_0 = groupId === void 1 ? null : groupId;
    var email_0 = email === void 1 ? null : email;
    var role_0 = role === void 1 ? null : role;
    this.groupId_1 = groupId_0;
    this.email_1 = email_0;
    this.role_1 = role_0;
    this.page_1 = page;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserGetAllQuery.prototype._get_groupId__2632351319_rhvmp5_k$ = function () {
    return this.groupId_1;
  };
  UserGetAllQuery.prototype._get_email__3207470005_hzgua3_k$ = function () {
    return this.email_1;
  };
  UserGetAllQuery.prototype._get_role__808279189_dd887p_k$ = function () {
    return this.role_1;
  };
  UserGetAllQuery.prototype._get_page__806010268_dbvli4_k$ = function () {
    return this.page_1;
  };
  UserGetAllQuery.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserGetAllQuery.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserGetAllQuery.$metadata$ = {
    simpleName: 'UserGetAllQuery',
    kind: 'class',
    interfaces: [KeycloakF2Command]
  };
  Object.defineProperty(UserGetAllQuery.prototype, 'groupId', {
    configurable: true,
    get: UserGetAllQuery.prototype._get_groupId__2632351319_rhvmp5_k$
  });
  Object.defineProperty(UserGetAllQuery.prototype, 'email', {
    configurable: true,
    get: UserGetAllQuery.prototype._get_email__3207470005_hzgua3_k$
  });
  Object.defineProperty(UserGetAllQuery.prototype, 'role', {
    configurable: true,
    get: UserGetAllQuery.prototype._get_role__808279189_dd887p_k$
  });
  Object.defineProperty(UserGetAllQuery.prototype, 'page', {
    configurable: true,
    get: UserGetAllQuery.prototype._get_page__806010268_dbvli4_k$
  });
  Object.defineProperty(UserGetAllQuery.prototype, 'realmId', {
    configurable: true,
    get: UserGetAllQuery.prototype._get_realmId__1266573383_ky329z_k$
  });
  function UserGetAllQueryResult(users) {
    this.users_1 = users;
  }
  UserGetAllQueryResult.prototype._get_users__3671205577_abddmf_k$ = function () {
    return this.users_1;
  };
  UserGetAllQueryResult.$metadata$ = {
    simpleName: 'UserGetAllQueryResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserGetAllQueryResult.prototype, 'users', {
    configurable: true,
    get: UserGetAllQueryResult.prototype._get_users__3671205577_abddmf_k$
  });
  function UserGetByEmailQuery(email, realmId, auth) {
    this.email_1 = email;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserGetByEmailQuery.prototype._get_email__3207470005_hzgua3_k$ = function () {
    return this.email_1;
  };
  UserGetByEmailQuery.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserGetByEmailQuery.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserGetByEmailQuery.$metadata$ = {
    simpleName: 'UserGetByEmailQuery',
    kind: 'class',
    interfaces: [KeycloakF2Command]
  };
  Object.defineProperty(UserGetByEmailQuery.prototype, 'email', {
    configurable: true,
    get: UserGetByEmailQuery.prototype._get_email__3207470005_hzgua3_k$
  });
  Object.defineProperty(UserGetByEmailQuery.prototype, 'realmId', {
    configurable: true,
    get: UserGetByEmailQuery.prototype._get_realmId__1266573383_ky329z_k$
  });
  function UserGetByEmailQueryResult(user) {
    this.user_1 = user;
  }
  UserGetByEmailQueryResult.prototype._get_user__811162592_dey128_k$ = function () {
    return this.user_1;
  };
  UserGetByEmailQueryResult.$metadata$ = {
    simpleName: 'UserGetByEmailQueryResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserGetByEmailQueryResult.prototype, 'user', {
    configurable: true,
    get: UserGetByEmailQueryResult.prototype._get_user__811162592_dey128_k$
  });
  function UserGetByIdQuery(id, realmId, auth) {
    this.id_1 = id;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserGetByIdQuery.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserGetByIdQuery.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserGetByIdQuery.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserGetByIdQuery.$metadata$ = {
    simpleName: 'UserGetByIdQuery',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserGetByIdQuery.prototype, 'id', {
    configurable: true,
    get: UserGetByIdQuery.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserGetByIdQuery.prototype, 'realmId', {
    configurable: true,
    get: UserGetByIdQuery.prototype._get_realmId__1266573383_ky329z_k$
  });
  Object.defineProperty(UserGetByIdQuery.prototype, 'auth', {
    configurable: true,
    get: UserGetByIdQuery.prototype._get_auth__792765859_d3zq1v_k$
  });
  function UserGetByIdQueryResult(user) {
    this.user_1 = user;
  }
  UserGetByIdQueryResult.prototype._get_user__811162592_dey128_k$ = function () {
    return this.user_1;
  };
  UserGetByIdQueryResult.$metadata$ = {
    simpleName: 'UserGetByIdQueryResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserGetByIdQueryResult.prototype, 'user', {
    configurable: true,
    get: UserGetByIdQueryResult.prototype._get_user__811162592_dey128_k$
  });
  function UserGetByUsernameQuery(realmId, auth, username) {
    this.realmId_1 = realmId;
    this.auth_1 = auth;
    this.username_1 = username;
  }
  UserGetByUsernameQuery.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserGetByUsernameQuery.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserGetByUsernameQuery.prototype._get_username__1834652085_ucaylx_k$ = function () {
    return this.username_1;
  };
  UserGetByUsernameQuery.$metadata$ = {
    simpleName: 'UserGetByUsernameQuery',
    kind: 'class',
    interfaces: [Command]
  };
  Object.defineProperty(UserGetByUsernameQuery.prototype, 'realmId', {
    configurable: true,
    get: UserGetByUsernameQuery.prototype._get_realmId__1266573383_ky329z_k$
  });
  Object.defineProperty(UserGetByUsernameQuery.prototype, 'auth', {
    configurable: true,
    get: UserGetByUsernameQuery.prototype._get_auth__792765859_d3zq1v_k$
  });
  Object.defineProperty(UserGetByUsernameQuery.prototype, 'username', {
    configurable: true,
    get: UserGetByUsernameQuery.prototype._get_username__1834652085_ucaylx_k$
  });
  function UserGetByUsernameQueryResult(user) {
    this.user_1 = user;
  }
  UserGetByUsernameQueryResult.prototype._get_user__811162592_dey128_k$ = function () {
    return this.user_1;
  };
  UserGetByUsernameQueryResult.$metadata$ = {
    simpleName: 'UserGetByUsernameQueryResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserGetByUsernameQueryResult.prototype, 'user', {
    configurable: true,
    get: UserGetByUsernameQueryResult.prototype._get_user__811162592_dey128_k$
  });
  function UserGetRolesQuery(userId, realmId, auth) {
    this.userId_1 = userId;
    this.realmId_1 = realmId;
    this.auth_1 = auth;
  }
  UserGetRolesQuery.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  UserGetRolesQuery.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  UserGetRolesQuery.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  UserGetRolesQuery.$metadata$ = {
    simpleName: 'UserGetRolesQuery',
    kind: 'class',
    interfaces: [KeycloakF2Command]
  };
  Object.defineProperty(UserGetRolesQuery.prototype, 'userId', {
    configurable: true,
    get: UserGetRolesQuery.prototype._get_userId__2138184069_zd0pdx_k$
  });
  Object.defineProperty(UserGetRolesQuery.prototype, 'realmId', {
    configurable: true,
    get: UserGetRolesQuery.prototype._get_realmId__1266573383_ky329z_k$
  });
  function UserGetRolesQueryResult(roles) {
    this.roles_1 = roles;
  }
  UserGetRolesQueryResult.prototype._get_roles__3581820084_bsl7ws_k$ = function () {
    return this.roles_1;
  };
  UserGetRolesQueryResult.$metadata$ = {
    simpleName: 'UserGetRolesQueryResult',
    kind: 'class',
    interfaces: [Event]
  };
  Object.defineProperty(UserGetRolesQueryResult.prototype, 'roles', {
    configurable: true,
    get: UserGetRolesQueryResult.prototype._get_roles__3581820084_bsl7ws_k$
  });
  function UserModel(id, email, firstName, lastName, roles, attributes) {
    this.id_1 = id;
    this.email_1 = email;
    this.firstName_1 = firstName;
    this.lastName_1 = lastName;
    this.roles_1 = roles;
    this.attributes_1 = attributes;
  }
  UserModel.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UserModel.prototype._get_email__3207470005_hzgua3_k$ = function () {
    return this.email_1;
  };
  UserModel.prototype._get_firstName__2810131542_ok16lm_k$ = function () {
    return this.firstName_1;
  };
  UserModel.prototype._get_lastName__3478880682_dhvkgm_k$ = function () {
    return this.lastName_1;
  };
  UserModel.prototype._get_roles__3581820084_bsl7ws_k$ = function () {
    return this.roles_1;
  };
  UserModel.prototype._get_attributes__2098778644_ypk3ys_k$ = function () {
    return this.attributes_1;
  };
  UserModel.$metadata$ = {
    simpleName: 'UserModel',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(UserModel.prototype, 'id', {
    configurable: true,
    get: UserModel.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(UserModel.prototype, 'email', {
    configurable: true,
    get: UserModel.prototype._get_email__3207470005_hzgua3_k$
  });
  Object.defineProperty(UserModel.prototype, 'firstName', {
    configurable: true,
    get: UserModel.prototype._get_firstName__2810131542_ok16lm_k$
  });
  Object.defineProperty(UserModel.prototype, 'lastName', {
    configurable: true,
    get: UserModel.prototype._get_lastName__3478880682_dhvkgm_k$
  });
  Object.defineProperty(UserModel.prototype, 'roles', {
    configurable: true,
    get: UserModel.prototype._get_roles__3581820084_bsl7ws_k$
  });
  Object.defineProperty(UserModel.prototype, 'attributes', {
    configurable: true,
    get: UserModel.prototype._get_attributes__2098778644_ypk3ys_k$
  });
  function UserRoles(assignedRoles, effectiveRoles) {
    this.assignedRoles_1 = assignedRoles;
    this.effectiveRoles_1 = effectiveRoles;
  }
  UserRoles.prototype._get_assignedRoles__2529550626_t7307y_k$ = function () {
    return this.assignedRoles_1;
  };
  UserRoles.prototype._get_effectiveRoles__3062278005_kdwt57_k$ = function () {
    return this.effectiveRoles_1;
  };
  UserRoles.$metadata$ = {
    simpleName: 'UserRoles',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(UserRoles.prototype, 'assignedRoles', {
    configurable: true,
    get: UserRoles.prototype._get_assignedRoles__2529550626_t7307y_k$
  });
  Object.defineProperty(UserRoles.prototype, 'effectiveRoles', {
    configurable: true,
    get: UserRoles.prototype._get_effectiveRoles__3062278005_kdwt57_k$
  });
  //region block: exports
  function $jsExportAll$(_) {
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserCreateCommand = UserCreateCommand;
    $i2$keycloak$f2$user$domain$features$command.UserCreatedResult = UserCreatedResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserDeleteCommand = UserDeleteCommand;
    $i2$keycloak$f2$user$domain$features$command.UserDeletedResult = UserDeletedResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserDisableCommand = UserDisableCommand;
    $i2$keycloak$f2$user$domain$features$command.UserDisabledResult = UserDisabledResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserEmailSendActionsCommand = UserEmailSendActionsCommand;
    $i2$keycloak$f2$user$domain$features$command.UserEmailSentActionsResult = UserEmailSentActionsResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserJoinGroupCommand = UserJoinGroupCommand;
    $i2$keycloak$f2$user$domain$features$command.UserGroupJoinedResult = UserGroupJoinedResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserRolesGrantCommand = UserRolesGrantCommand;
    $i2$keycloak$f2$user$domain$features$command.UserRolesGrantedResult = UserRolesGrantedResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserRolesRevokeCommand = UserRolesRevokeCommand;
    $i2$keycloak$f2$user$domain$features$command.UserRolesRevokedResult = UserRolesRevokedResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$command = $i2$keycloak$f2$user$domain$features.command || ($i2$keycloak$f2$user$domain$features.command = {});
    $i2$keycloak$f2$user$domain$features$command.UserUpdateCommand = UserUpdateCommand;
    $i2$keycloak$f2$user$domain$features$command.UserUpdatedResult = UserUpdatedResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$query = $i2$keycloak$f2$user$domain$features.query || ($i2$keycloak$f2$user$domain$features.query = {});
    $i2$keycloak$f2$user$domain$features$query.UserGetAllQuery = UserGetAllQuery;
    $i2$keycloak$f2$user$domain$features$query.UserGetAllQueryResult = UserGetAllQueryResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$query = $i2$keycloak$f2$user$domain$features.query || ($i2$keycloak$f2$user$domain$features.query = {});
    $i2$keycloak$f2$user$domain$features$query.UserGetByEmailQuery = UserGetByEmailQuery;
    $i2$keycloak$f2$user$domain$features$query.UserGetByEmailQueryResult = UserGetByEmailQueryResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$query = $i2$keycloak$f2$user$domain$features.query || ($i2$keycloak$f2$user$domain$features.query = {});
    $i2$keycloak$f2$user$domain$features$query.UserGetByIdQuery = UserGetByIdQuery;
    $i2$keycloak$f2$user$domain$features$query.UserGetByIdQueryResult = UserGetByIdQueryResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$query = $i2$keycloak$f2$user$domain$features.query || ($i2$keycloak$f2$user$domain$features.query = {});
    $i2$keycloak$f2$user$domain$features$query.UserGetByUsernameQuery = UserGetByUsernameQuery;
    $i2$keycloak$f2$user$domain$features$query.UserGetByUsernameQueryResult = UserGetByUsernameQueryResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$features = $i2$keycloak$f2$user$domain.features || ($i2$keycloak$f2$user$domain.features = {});
    var $i2$keycloak$f2$user$domain$features$query = $i2$keycloak$f2$user$domain$features.query || ($i2$keycloak$f2$user$domain$features.query = {});
    $i2$keycloak$f2$user$domain$features$query.UserGetRolesQuery = UserGetRolesQuery;
    $i2$keycloak$f2$user$domain$features$query.UserGetRolesQueryResult = UserGetRolesQueryResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$model = $i2$keycloak$f2$user$domain.model || ($i2$keycloak$f2$user$domain.model = {});
    $i2$keycloak$f2$user$domain$model.UserModel = UserModel;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$user = $i2$keycloak$f2.user || ($i2$keycloak$f2.user = {});
    var $i2$keycloak$f2$user$domain = $i2$keycloak$f2$user.domain || ($i2$keycloak$f2$user.domain = {});
    var $i2$keycloak$f2$user$domain$model = $i2$keycloak$f2$user$domain.model || ($i2$keycloak$f2$user$domain.model = {});
    $i2$keycloak$f2$user$domain$model.UserRoles = UserRoles;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_city_smartb_i2_user_domain.js.map